import React, { useState, useEffect, useContext } from 'react';

// Context

//Styles 
import newStyle from "./NewSelectCategoryStyle.module.css";
import Dstyles from "../../../DashboardFileManagement.module.css"
import 'react-toastify/dist/ReactToastify.css';
// import userStyles from "../../../UserDashboard/UserAddNewFile/UserAddNewFile.module.css"

// Re Useable Components
import DashboardSideMenu from '../../../../DashboardReuseAbleComponents/DashboardSideMenu';
import ShowProfileModal from '../../../CardDetail/ShowProfileModal';
import EditCategoryModal from '../../../../DashboardAddNewFile/EditCategory/EditCategoryModal';
import DashboardHeader from '../../../../DashboardReuseAbleComponents/DashboardHeader';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import { UserContext } from '../../../../../Context/UserContextProvider';

import arrowIcon from "../../../../../../assets/img/DashboardICons/ArrowRounded.svg"


const SelectCategory = (props) => {
    let state = useLocation();
    let history = useHistory();

    const { userToken, permissions } = useContext(UserContext)
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState();
    const [showPage, setShowPage] = useState({
        pageNumber: 1,
        categoriID: "",
        categoriTitle: "",
        subCategoryID: "",
        selectedSub: "",
        subIsSelected: false
    })
    const [modalShow, setModalShow] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [userpermissions, setUserpermissions] = useState({
        isSuperUser: "",
        isConsultant: ""
    })

    let [showingCategories, setShwoingCategories] = useState([]);

    useEffect(() => {
        axios.get("Category", {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            let categories = res.data?.data || [];

            setCategories(res.data?.data || []);

            let selectedCategory = categories.find((c) => c.id == state?.state?.state?.categoryId || 0);

            setShwoingCategories(categories.filter((c) => c.parentId == selectedCategory.parentId));

            setIsLoading(false);
        });
    }, []);

    console.log(state.state.state);

    useEffect(() => {
        sessionStorage.removeItem("searchData");
        sessionStorage.removeItem("pageData");
        sessionStorage.removeItem("categories");
        sessionStorage.removeItem("subCategory");
        sessionStorage.removeItem("mainCategory");
        sessionStorage.removeItem("dealType");
        sessionStorage.removeItem("filters");
    }, []);

    useEffect(() => {
        if (permissions) {
            const isSuperUser = permissions.find((item => item === 0))
            const isConsultant = permissions.find((item => item === 11))
            setUserpermissions((prev) => {
                return { ...prev, isSuperUser: isSuperUser, isConsultant: isConsultant };
            });
        }

    }, [permissions]);

    function submitHandler(regionId){
        axios.put("Estate/Region", {
            EstateId: state?.state?.state?.id || 0,
            RegionId: regionId
        }, {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            history.push(`/card-detail/${state?.state?.state?.id || 0}`);
        });
    }

    function goBack(){
        history.push(`/card-detail/${state?.state?.state?.id || 0}`);
    }

    return (
        <>
            <style type="text/css">
                {`
                    .dropdown-toggle {
                        width: 170px;
                        height: 44px;
                        background: #f9f9f9;
                        border: 1px solid #e2e2e2;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        border: 1px solid #e2e2e2 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        width: 170px;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
    `}
            </style>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <EditCategoryModal
                show={editModalShow}
                onHide={() => setEditModalShow(false)}
                categories={categories}
            />


            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-0 ${Dstyles.container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} />

                                    <div className="py-2">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2 ${newStyle.pointer}`} onClick={goBack}>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                                        <div className={Dstyles.text1}>
                                                            ویرایش منطقه فایل
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${newStyle.main_container}`}>
                                                    <div className={`${newStyle.main_categories_container}`}>
                                                        {
                                                            showingCategories.map((category) => {
                                                                return  <div className={`${newStyle.category_button}`} onClick={() => {submitHandler(category.id)}}>
                                                                            <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                                                            <div className={`${newStyle.category_button_content}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{width: "20px", height: "20px"}}><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"/></svg></div>
                                                                        </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu addNewFile/>
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}

        </>
    );
};

export default React.memo(SelectCategory);